module.exports = __webpack_public_path__ + "img/popup_bg_s6_mob.ded92c06.png";